export function recordOvertakeOutcome(
  overtakesSucceeded: number[],
  overtakesCountered: number[],
  attackerIndex: number,
  defenderIndex: number,
  success: boolean
): void {
  if (success) {
    overtakesSucceeded[attackerIndex] = (overtakesSucceeded[attackerIndex] ?? 0) + 1;
    return;
  }
  overtakesCountered[defenderIndex] = (overtakesCountered[defenderIndex] ?? 0) + 1;
}

export function recordOvertakeOutcomes(
  overtakesSucceeded: number[],
  overtakesCountered: number[],
  attackerIndex: number,
  overtakes: readonly { defenderIndex: number; success: boolean }[]
): void {
  for (const overtake of overtakes) {
    recordOvertakeOutcome(
      overtakesSucceeded,
      overtakesCountered,
      attackerIndex,
      overtake.defenderIndex,
      overtake.success
    );
  }
}

export type RaceOvertakeBioKind = 'succeeded' | 'countered';

export interface RaceOvertakeBioLine {
  kind: RaceOvertakeBioKind;
  text: string;
}

/** Lignes séparées pour le tooltip (réussis puis contrés). */
export function formatRaceOvertakeBioLines(
  succeeded: number,
  countered: number
): RaceOvertakeBioLine[] {
  const lines: RaceOvertakeBioLine[] = [];
  if (succeeded > 0) {
    lines.push({
      kind: 'succeeded',
      text: `${succeeded} dépassement${succeeded > 1 ? 's' : ''} réussi${succeeded > 1 ? 's' : ''}`,
    });
  }
  if (countered > 0) {
    lines.push({
      kind: 'countered',
      text: `${countered} dépassement${countered > 1 ? 's' : ''} contré${countered > 1 ? 's' : ''}`,
    });
  }
  return lines;
}

/** Texte compact (une ligne) — conservé pour usages legacy. */
export function formatRaceOvertakeBio(succeeded: number, countered: number): string | null {
  const lines = formatRaceOvertakeBioLines(succeeded, countered);
  return lines.length > 0 ? lines.map((l) => l.text).join(' · ') : null;
}
